export default __webpack_public_path__ + "static/media/maorstory.35a7d0ba.svg";